
import axios from "axios";
// import {jwtDecode} from "jwt-decode";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data () {
      return {
        fullJson:"",
        jsonRespon:"",
        dialog_detail: false, // Untuk mengontrol dialog
        headers: [
          { text: 'Topic', value: 'GROUP_NAME' },
          { text: 'Periode', value: 'PERIOD' },
          { text: 'Endpoint', value: 'ENDPOINT' },
          { text: 'Time Send', value: 'CREATED_AT' },
          { text: 'Status', value: 'STATUS' },
          { text: 'Information', value: 'JSON_SEND' },
          // { text: 'Actions', value: 'actions', sortable: false },
        ],
        datatablesna: [],
        tableLoading: false,
        totalData: 0,
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['SEQ_ID'],
          sortDesc: [true],
        },
        selectedendpointFilter: null,
        startDate: '',
        endDate: '',


        dataGroupAnalysis: [], 
        DialogBrandHealthIndex: false,
        dialogNewsInsight: false,
        dialogAnalyzePenetration: false,
        dialogNewsTimelineHighlight: false,
        datatopic: [], 
        datatopictagcloude: [], 
        filter_collection:false,
        filter_group_analysis:false,
        filter_topic:true,
        filter_periode:true,
        keyword_method_val:false,
        levelHonecVal:false,
        topEmotion:false,
        selectedendpoint:"",
        selectedcolection:"Twitter",
        collection: [
          "Twitter",
          "News",
          "Instagram",
          "Youtube",
          "Tik Tok",
        ],
        tableLoading: false, 
        isCommaError: [], // Status error koma
        groupAnalysis: [],
        selectedGroupAnalysis: "",
        topicsentiment: [],
        btnload:false,
        name_action_dialog: '',
        title_dialog: '',
        alert_err_attention: "",
        alertFailed: "",
        alertSuccess: "",
        search: "",
        selectedTopic: "",
        dialogview : false,
        dialogTagcloude : false,
        selectedPeriode: "All",
        periodeberita: ['All','Today', 'From Yesterday', 'This Week', 'Previous Week', 'This Month', 'Previous Month'],
        selectedEndpoint: "TAG CLOUDE",
        endpointvalue: [
         "SNA",
         "SEMANTIC",
         "TAG CLOUDE",
          "HONEYCON",
          "EMOTION",
          "Brand Health Index",
          "News Insight",
          "Analyze Penetration",
          "Analyze Penetration",
          "News Timeline Highlight",
        ],
        chip1: true,
        chip2: true,
        chip3: true,
        chip4: true,
      }
    },
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
    },
    mounted(){
      this.loadGroupAnalysis();
      this.loadTopic();
      this.initialize();
      this.FilterSelectendpoint();
      

    },
    methods:{   
      openDialog(jsonData,jsonRespon) {
        this.fullJson = JSON.stringify(JSON.parse(jsonData), null, 2) ;
        this.jsonRespon = JSON.stringify(JSON.parse(jsonRespon), null, 2) ;
        this.dialog_detail = true;
      },
    
      openDialogDetail (item) {
        this.seq_id = item
        this.dialog = true
        axios({
          method: "put",
          url: "get-json-send",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then(async (response) => {
            let result = decryptionData(response.data.token);
            console.log(result);

          this.fullJson = JSON.stringify(JSON.parse(result.JSON_SEND), null, 2) ;
          this.jsonRespon = JSON.stringify(JSON.parse(result.RESPONSE_DATA), null, 2) ;
          this.dialog_detail = true;
          
            setTimeout(() =>{
              this.loading = false
            },1000)
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },

      async FilterSelectendpoint() {
          this.filter_group_analysis = false
          this.filter_topic = true
          this.filter_periode = true
        if(this.selectedendpoint == "SNA"){
          this.filter_collection = true
        }else if(this.selectedendpoint == "HONEYCON"){
          this.filter_collection = false
          this.keyword_method_val = false
          this.levelHonecVal = true
          this.topEmotion = false

        }else if(this.selectedendpoint == "EMOTION"){
          this.filter_collection = false
          this.keyword_method_val = false
          this.levelHonecVal = false
          this.topEmotion = true
          
          
        }else if(this.selectedendpoint == "Brand Health Index"){
          this.filter_group_analysis = true
          this.filter_collection = false
          this.filter_topic = false
          this.filter_periode = false
        }else if(this.selectedendpoint == "News Insight"){
          this.filter_group_analysis = true
          this.filter_collection = false
          this.filter_topic = false
          this.filter_periode = false
          
        }else if(this.selectedendpoint == "Analyze Penetration"){
          this.filter_group_analysis = true
          this.filter_collection = false
          this.filter_topic = false
          this.filter_periode = true
          
        }else if(this.selectedendpoint == "News Timeline Highlight"){
          this.filter_group_analysis = true
          this.filter_collection = false
          this.filter_topic = false
          this.filter_periode = false
          
        }else {
          this.filter_collection = false
          this.keyword_method_val = true
          this.levelHonecVal = false
          this.topEmotion = false

        }
      },

      handleOptions(options) {
        this.options = options;
        this.initialize();
      },

      filterContent() {
        if (this.startDate && this.endDate &&
            this.startDate > this.endDate) {
          alert('End Date tidak boleh lebih kecil dari Start Date');
          return;
        }
        this.options.page = 1;
        this.initialize();
      },

      resetFilter() {
        this.selectedendpointFilter = null;
        this.startDate = '';
        this.endDate = '';

        this.options.page = 1;

        this.initialize();
      },
      // initialize() {
      //   this.tableLoading = true;

      //   axios.get("data-send-topic", {
      //     headers: {
      //       'auth-token': localStorage.getItem('token_app')
      //     },
      //     params: {
      //       page: this.options.page,
      //       limit: this.options.itemsPerPage
      //     }
      //   })
      //   .then((response) => {
      //     const res = decryptionData(response.data.data);

      //     this.datatablesna = res.result;
      //     this.totalData = res.pagination.totalData;

      //     setTimeout(() => {
      //       this.loading = false;
      //     }, 1000);

      //     if (localStorage.getItem('authactdeletedt') == 1) {
      //       this.deleteact = true;
      //     }

      //     if (localStorage.getItem('authactinsert') == 1) {
      //       this.insertact = true;
      //     }

      //     if (localStorage.getItem('authactupdate') == 1) {
      //       this.updateact = true;
      //     }

      //     if (localStorage.getItem('authactview') == 1) {
      //       this.viewact = true;
      //     }
      //   })
      //   .catch((e) => {
      //     if (e.response) {
      //       switch (e.response.status) {
      //         case 404:
      //           this.$refs.alert.error_login(404);
      //           break;
      //         case 403:
      //           this.$refs.alert.error_login(403);
      //           break;
      //         default:
      //           console.log('some other error');
      //           break;
      //       }
      //     }

      //     this.errors = e.response?.data?.msg;
      //   })
      //   .finally(() => {
      //     this.tableLoading = false;
      //   });
      // },

      initialize() {
        this.tableLoading = true;

        axios.get("data-send-topic", {
          headers: {
            'auth-token': localStorage.getItem('token_app')
          },
          params: {
            page: this.options.page,
            limit: this.options.itemsPerPage,
            endpoint: this.selectedendpointFilter || '',
            startDate: this.startDate || '',
            endDate: this.endDate || ''
          }
        })
        .then((response) => {
          const res = decryptionData(response.data.data);

          this.datatablesna = res.result;
          this.totalData = res.pagination.totalData;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.tableLoading = false;
        });
      },
      async loadGroupAnalysis() {
        axios.get("analisis-group-user",
          { headers: { 'auth-token': localStorage.getItem('token_app') } },
          { dataType: 'json' }
        )
        .then((response) => {
          const data_dec = decryptionData(response.data.token);
          const data = data_dec.data;
          this.groupAnalysis.unshift({
              SEQ_ID: "",
              GROUP_ANALYSIS: "All"
          });
          this.selectedTopic = "";
          for (let i = 0; i < data.length; i++) {
            this.groupAnalysis.push(data[i]);
          }
          
        })
        .catch((e) => {
          if (e.response) {
            const { status } = e.response;

            switch (status) {
              case 404:
                this.$refs.alert.error_login(404);
                break;
              case 403:
                this.$refs.alert.error_login(403);
                break;
              default:
                console.log("some other error"); // end up here all the time
                break;
            }
          } else {
            this.alert = true;
            setTimeout(() => {
              this.alert = false;
            }, 10000);
            this.message = "API Keyword Select refused to connect";
            this.colorAlert = "red";
          }
        });
      },
      async loadTopic() {
        axios.get("keyword_select",
          { headers: { 'auth-token': localStorage.getItem('token_app') } },
          { dataType: 'json' }
        )
        .then((response) => {
          const data_dec = decryptionData(response.data.token);
          this.posts = data_dec.keyword;
          const data = data_dec.keyword;
          this.topicsentiment.unshift({
              SEQ_ID: "",
              TOPIC: "All"
          });
          this.selectedTopic = "";
          for (let i = 0; i < data.length; i++) {
            this.topicsentiment.push(data[i]);
          }
          
        })
        .catch((e) => {
          if (e.response) {
            const { status } = e.response;

            switch (status) {
              case 404:
                this.$refs.alert.error_login(404);
                break;
              case 403:
                this.$refs.alert.error_login(403);
                break;
              default:
                console.log("some other error"); // end up here all the time
                break;
            }
          } else {
            this.alert = true;
            setTimeout(() => {
              this.alert = false;
            }, 10000);
            this.message = "API Keyword Select refused to connect";
            this.colorAlert = "red";
          }
        });
    },
      viewtopicsend(){
        if(this.selectedendpoint == undefined){
          this.alertFailed = true;
          this.alert_err_attention =  "Endpoint Not Selected";
        }else{
            // ======== sort topic 
            let filteredData = []
            if(this.selectedTopic == ""){
              filteredData = this.topicsentiment.filter(item => item.TOPIC !== "All")
                              .map(item => ({
                                SEQ_ID: item.SEQ_ID,
                                id_topic: item.SEQ_ID,
                                TOPIC: item.TOPIC,
                                topic_name: item.TOPIC
                              }));

            }else{
              filteredData = this.topicsentiment.filter(item => item.SEQ_ID == this.selectedTopic)
                              .map(item => ({
                                SEQ_ID: item.SEQ_ID,
                                id_topic: item.SEQ_ID,
                                TOPIC: item.TOPIC,
                                topic_name: item.TOPIC
                              }));
            }
            if (this.selectedTopic) {
              const selectedItem = this.topicsentiment.find(item => item.SEQ_ID == this.selectedTopic);
              if (selectedItem) {
                this.name_action_dialog = 'Topic : '+selectedItem.TOPIC+' And Periode : '+this.selectedPeriode;
              }
            } else {
              this.name_action_dialog = 'Topic : All And Periode : '+this.selectedPeriode;
            }
            // ==== sort group analysis 

            let filteredDataGroupAnalysis = []
            if(this.selectedGroupAnalysis == ""){
              filteredDataGroupAnalysis = this.groupAnalysis.filter(item => item.GROUP_ANALYSIS !== "All")
                              .map(item => ({
                                SEQ_ID: item.SEQ_ID,
                                GROUP_ANALYSIS: item.GROUP_ANALYSIS,
                                id_group_analysis: item.SEQ_ID,
                                name_group_analysis: item.GROUP_ANALYSIS,
                              }));

            }else{
              filteredDataGroupAnalysis = this.groupAnalysis.filter(item => item.SEQ_ID == this.selectedGroupAnalysis)
                              .map(item => ({
                                SEQ_ID: item.SEQ_ID,
                                GROUP_ANALYSIS: item.GROUP_ANALYSIS,
                                id_group_analysis: item.SEQ_ID,
                                name_group_analysis: item.GROUP_ANALYSIS,
                              }));
            }

            this.title_dialog = this.selectedendpoint
            if(this.selectedendpoint == "SNA"){
                this.datatopic =[]
                this.datatopic = filteredData
                this.dialogview = true
            }else if (this.selectedendpoint == "SEMANTIC"){
                this.datatopic =[]
                this.datatopic = filteredData
                this.dialogSemanticview = true

            }else if(this.selectedendpoint == "Brand Health Index"){
                this.dataGroupAnalysis =[]
                this.dataGroupAnalysis = filteredDataGroupAnalysis
                this.DialogBrandHealthIndex = true

            }else if(this.selectedendpoint == "News Insight"){
                this.dataGroupAnalysis =[]
                this.dataGroupAnalysis = filteredDataGroupAnalysis
                this.dialogNewsInsight = true

            }else if(this.selectedendpoint == "Analyze Penetration"){
                this.dataGroupAnalysis =[]
                this.dataGroupAnalysis = filteredDataGroupAnalysis.map(item => ({
                  ...item,
                  period: this.selectedPeriode
                }))
                this.dialogAnalyzePenetration = true

            }else if(this.selectedendpoint == "News Timeline Highlight"){
                this.dataGroupAnalysis =[]
                this.dataGroupAnalysis = filteredDataGroupAnalysis
                this.dialogNewsTimelineHighlight = true

            }else{
              
              this.datatopictagcloude =[]
                this.datatopictagcloude = filteredData
                this.dialogTagcloude = true
                console.log(filteredData)

            }
        }

      },
      async postsna(){
          const dataToSend = this.datatopic.map(item => ({
            id_topic: item.id_topic,
            topic_name: item.topic_name !== undefined ? item.topic_name : null,
            mode: item.mode !== undefined ? item.mode : null,
            window: item.window !== undefined ? item.window : null,
            lower_bound: item.lower_bound !== undefined ? item.lower_bound : null,
          }));

          const payload = {
            data: dataToSend,
            period: this.selectedPeriode,
            source: this.selectedcolection
          };
          console.log(dataToSend);

                this.btnload = true
        try {
          const response = await axios.post('/send-topic-sna', payload, {
            headers: {
              'auth-token': localStorage.getItem('token_app')
            }
          });
          // console.log(response.data);
          if(response.data.status == 200){
                this.alertSuccess = true;
                this.dialogview = false
                this.alert_err_attention =  response.data.messages
                this.initialize ();
                this.close();
          }else{
                this.alertFailed = true;
                this.alert_err_attention =  response.data.messages;
          }
          this.btnload = false; // Matikan tombol loading
        } catch (error) {
          console.error('Error:', error);
          this.btnload = false; // Matikan tombol loading
        }
      },

      async postBrandHealthIndex(){
          const dataToSend = this.dataGroupAnalysis.map(item => ({
            id_group_analysis: item.id_group_analysis,
            name_group_analysis: item.name_group_analysis,
            news_const: item.news_const,
            socmed_const: item.socmed_const !== undefined ? item.socmed_const : null,
            brand_sentiment_const: item.brand_sentiment_const !== undefined ? item.brand_sentiment_const : null,
            brand_authority_const: item.brand_authority_const !== undefined ? item.brand_authority_const : null,
            brand_sov_const: item.brand_sov_const !== undefined ? item.brand_sov_const : null,
            base_model: item.base_model !== undefined ? item.base_model : null,
            model_name: item.model_name !== undefined ? item.model_name : null,
          }));

          const payload = {
            data: dataToSend,
          };

                this.btnload = true
        try {
          const response = await axios.post('/send-pr-health-index', payload, {
            headers: {
              'auth-token': localStorage.getItem('token_app')
            }
          });
          // console.log(response.data);
          if(response.data.status == 200){
                this.alertSuccess = true;
                this.dialogview = false
                this.alert_err_attention =  response.data.messages
                this.initialize ();
                this.closeBrandHealthIndex();
          }else{
                this.alertFailed = true;
                this.alert_err_attention =  'Gagal Send Data';
          }
          this.btnload = false; // Matikan tombol loading
        } catch (error) {
          console.error('Error:', error);
          this.btnload = false; // Matikan tombol loading
        }
      },
      async postNewsInsight(){
          const dataToSend = this.dataGroupAnalysis.map(item => ({
            id_group_analysis: item.id_group_analysis,
            name_group_analysis: item.name_group_analysis,
            base_model: item.base_model !== undefined ? item.base_model : null,
            model: item.model !== undefined ? item.model : null,
          }));

          const payload = {
            data: dataToSend,
          };

                this.btnload = true
        try {

          const response = await axios.post('/send-news-insights', payload, {
            headers: {
              'auth-token': localStorage.getItem('token_app')
            }
          });
          if(response.data.status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  response.data.messages
                this.initialize ();
                this.closeNewsInsight();
          }else{
                this.alertFailed = true;
                this.alert_err_attention =  'Gagal Send Data';
          }
          this.btnload = false;
        } catch (error) {
          console.error('Error:', error);
          this.btnload = false;
        }
      },

      async postAnalyzePenetration(){
          const dataToSend = this.dataGroupAnalysis.map(item => ({
            id_group_analysis: item.id_group_analysis,
            name_group_analysis: item.name_group_analysis,
            period: item.period !== undefined ? item.period : this.selectedPeriode,
            match_threshold: item.match_threshold !== undefined ? item.match_threshold : null,
            echo_threshold: item.echo_threshold !== undefined ? item.echo_threshold : null,
          }));

          const payload = {
            data: dataToSend,
          };

                this.btnload = true
        try {

          const response = await axios.post('/send-analyzer-penetration', payload, {
            headers: {
              'auth-token': localStorage.getItem('token_app')
            }
          });
          if(response.data.status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  response.data.messages
                this.initialize ();
                this.closeAnalyzePenetration();
          }else{
                this.alertFailed = true;
                this.alert_err_attention =  'Gagal Send Data';
          }
          this.btnload = false;
        } catch (error) {
          console.error('Error:', error);
          this.btnload = false;
        }
      },

      async postNewsTimelineHighlight(){
          const dataToSend = this.dataGroupAnalysis.map(item => ({
            id_group_analysis: item.id_group_analysis,
            name_group_analysis: item.name_group_analysis,
            base_model: item.base_model !== undefined ? item.base_model : null,
            model: item.model !== undefined ? item.model : null,
            force_recreate: item.force_recreate !== undefined ? item.force_recreate : null,
          }));

          const payload = {
            data: dataToSend,
          };

                this.btnload = true
        try {
          const response = await axios.post('/send-news-timeline-highlight', payload, {
            headers: {
              'auth-token': localStorage.getItem('token_app')
            }
          });
          if(response.data.status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  response.data.messages
                this.initialize ();
                this.closeNewsTimelineHighlight();
          }else{
                this.alertFailed = true;
                this.alert_err_attention =  'Gagal Send Data';
          }
          this.btnload = false;
        } catch (error) {
          console.error('Error:', error);
          this.btnload = false;
        }
      },

      async postSemantic(){
          const dataToSend = this.datatopic.map(item => ({
            id_topic: item.id_topic,
            topic_name: item.topic_name !== undefined ? item.topic_name : null,
            min_distance: item.min_distance !== undefined ? item.min_distance : null,
            spreadness: item.spreadness !== undefined ? item.spreadness : null,
          }));

          const payload = {
            data: dataToSend,
            period: this.selectedPeriode,
            source: this.selectedcolection
          };
          console.log(dataToSend);

                this.btnload = true
        try {
          const response = await axios.post('/send-topic-semantic', payload, {
            headers: {
              'auth-token': localStorage.getItem('token_app')
            }
          });
          // console.log(response.data);
          if(response.data.status == 200){
                this.dialogSemanticview = false
                this.alertSuccess = true;
                this.alert_err_attention =  response.data.messages
                this.initialize ();
                this.close();
          }else{
                this.alertFailed = true;
                this.alert_err_attention =  response.data.messages;
          }
          this.btnload = false; // Matikan tombol loading
        } catch (error) {
          console.error('Error:', error);
          this.btnload = false; // Matikan tombol loading
        }
      },
      
      async posttag(){
          const dataToSend = this.datatopictagcloude.map(item => ({
            id_topic: item.id_topic,
            topic_name: item.topic_name !== undefined ? item.topic_name : null,
            keyword_min: item.keywordMin !== undefined ? item.keywordMin : null,
            keyword_max: item.keywordMax !== undefined ? item.keywordMax : null,
            level: item.levelCluster !== undefined ? item.levelCluster : null,
            keyword_method: item.keywordMethod !== undefined ? item.keywordMethod : null,
            topEmotion: item.topEmotion !== undefined ? item.topEmotion : null,
          }));

          const payload = {
            endpoint:this.title_dialog,
            data: dataToSend,
            period: this.selectedPeriode
          };
          console.log(dataToSend);

                this.btnload = true
        try {
          const response = await axios.post('/send-tag-hanic', payload, {
            headers: {
              'auth-token': localStorage.getItem('token_app')
            }
          });
          console.log(response.data);
          
          var res = decryptionData(response.data.data);
          if(res.status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  res.messages
                this.initialize ();
                this.closeTag();
          }else{
                this.alertFailed = true;
                this.alert_err_attention =  res.messages;
          }
          this.btnload = false; // Matikan tombol loading
          // Handle sukses
        } catch (error) {
          console.error('Error:', error);
          this.alertFailed = true;
          this.alert_err_attention =  error;
          this.btnload = false; // Matikan tombol loading
        }
      },
      
      close () {
        
        this.isAdd = false  
        
        this.dialogview = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      
      closeTag () {
        
        this.isAdd = false  
        
        this.dialogTagcloude = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeBrandHealthIndex () {
        this.isAdd = false  
        this.DialogBrandHealthIndex = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeNewsInsight () {
        this.isAdd = false  
        this.dialogNewsInsight = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeAnalyzePenetration () {
        this.isAdd = false  
        this.dialogAnalyzePenetration = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeNewsTimelineHighlight () {
        this.isAdd = false  
        this.dialogNewsTimelineHighlight = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      
    }
  }